<template>
  <div class="page-content home-wrap">
    <div class="home-head">
      <el-row :gutter="20">
        <el-col :sm="24" :lg="12">
          <div class="grid-content bg-purple">
            <h2>{{ $t("overview.billing.header") }}</h2>
            <div class="grid-card">
              <ul class="clearfix">
                <li>
                  <p>{{ $store.state.currency }} {{ $util.convertCurrency(balance) }}</p>
                  <p>{{ $t('overview.billing.availableCredit') }}</p>
                </li>
                <li>
                  <p>{{ $store.state.currency }} {{ $util.convertCurrency(log_money) }}</p>
                  <p>{{ $t('overview.billing.consumptionTip') }}</p>
                </li>
              </ul>
              <a href="javascript:void(0);" class="addbtn" @click="rechargeItem">{{ $t('overview.billing.addFunds') }}</a>
            </div>
          </div>
        </el-col>
        <!--
        <el-col :sm="24" :lg="12">
          <div class="grid-content bg-purple">
           <h2>{{ $t("index.Referral") }}</h2>
            <div class="grid-card">
              <dl class="grid-card-info">
                <dt class="clearfix">
                  <p>Refer Vultr.com and earn $10 per paid signup!</p>
                  <a href="#">More</a>
                </dt>
                <dd>
                  <p>Give $100, Get $25.</p>
                  <p>
                    Tell A Friend about Vultr and Earn up to $25 for referring
                    clients!
                  </p>
                </dd>
              </dl>
              <div class="copyurl">
                {{ copyurl }}
                <span class="el-icon-document-copy copy"
                      v-clipboard="copyurl"
                      v-clipboard:success="clipboardSuccessHandler"
                      v-clipboard:error="clipboardErrorHandler"></span>
              </div>
            </div>
          </div>
        </el-col>
        -->
      </el-row>
    </div>

    <div class="home-products">
      <h2>{{ $t("overview.products.header") }}</h2>
      <div class="products-wrap">
        <el-row :gutter="20">
            <el-col :sm="12" :lg="8">
              <a :href="wwwUrl+'/ecc'"  target="_blank">
              <div class="grid-content bg-purple">
                <div class="products-item">
                  <div class="icon-img">
                    <p class="nor-icon">
                      <svg class="icon" aria-hidden="true">
                        <use
                          v-bind:xlink:href="`#icon-gailan_fuwuqi_nor`"
                        ></use>
                      </svg>
                    </p>
                    <p class="hover-icon">
                      <svg class="icon" aria-hidden="true">
                        <use
                          v-bind:xlink:href="`#icon-gailan_fuwuqi_sel`"
                        ></use>
                      </svg>
                    </p>
                  </div>
                  <dl>
                    <dt>{{ $t('overview.products.ecc.header') }}</dt>
                    <dd>{{ $t('overview.products.ecc.introduction') }} </dd>
                  </dl>
                </div>
              </div>
          </a>
            </el-col>


            <el-col :sm="12" :lg="8">
              <a :href="wwwUrl+'/bms'" target="_blank">
              <div class="grid-content bg-purple">
                <div class="products-item">
                   <div class="icon-img">
                    <p class="nor-icon">
                      <svg class="icon" aria-hidden="true">
                        <use :xlink:href="`#icon-gailan_luojinshu_nor`"></use>
                      </svg>
                    </p>
                    <p class="hover-icon">
                      <svg class="icon" aria-hidden="true">
                        <use :xlink:href="`#icon-gailan_luojinshu_sel`"></use>
                      </svg>
                    </p>
                  </div>
                  <dl>
                    <dt>{{ $t('overview.products.bms.header') }}</dt>
                    <dd>{{ $t('overview.products.bms.introduction') }}</dd>
                  </dl>
                </div>
              </div>
          </a>
            </el-col>


            <el-col :sm="12" :lg="8">
              <a :href ="wwwUrl+'/mysql'" target="_blank">
              <div class="grid-content bg-purple">
                <div class="products-item">
                  <div class="icon-img">
                    <p class="nor-icon">
                      <svg class="icon" aria-hidden="true">
                        <use :xlink:href="`#icon-gailan_Mysql_norv`"></use>
                      </svg>
                    </p>
                    <p class="hover-icon">
                      <svg class="icon" aria-hidden="true">
                        <use :xlink:href="`#icon-gailan_Mysql_sel`"></use>
                      </svg>
                    </p>
                  </div>
                  <dl>
                    <dt>{{ $t('overview.products.mysql.header') }}</dt>
                    <dd>{{ $t('overview.products.mysql.introduction') }}</dd>
                  </dl>
                </div>
              </div>
             </a>
            </el-col>

          <!--
          <router-link :to="{ path: '/slb/index/instance', query: {} }">
            <el-col :sm="12" :lg="8">
              <div class="grid-content bg-purple">
                <div class="products-item">
                   <div class="icon-img">
                    <p class="nor-icon">
                      <svg class="icon" aria-hidden="true">
                        <use :xlink:href="`#icon-gailan_fuzaijunheng_nor`"></use>
                      </svg>
                    </p>
                    <p class="hover-icon">
                      <svg class="icon" aria-hidden="true">
                        <use :xlink:href="`#icon-gailan_fuzaijunheng_sel`"></use>
                      </svg>
                    </p>
                  </div>
                  <dl>
                    <dt>Elastic Load Balancer (ELB)</dt>
                    <dd>
                      It can quickly improve the external service capabilities
                      of the application system through traffic distribution.
                      The actual access port is hidden, which can enhance the
                      security of the internal system.
                    </dd>
                  </dl>
                </div>
              </div>
            </el-col>
          </router-link>
          <router-link :to="{ path: '/ssl/instance', query: {} }">
            <el-col :sm="12" :lg="8">
              <div class="grid-content bg-purple">
                <div class="products-item">
                  <div class="icon-img">
                     <p class="nor-icon">
                      <svg class="icon" aria-hidden="true">
                        <use :xlink:href="`#icon-gailan_SSL_nor`"></use>
                      </svg>
                    </p>
                    <p class="hover-icon">
                      <svg class="icon" aria-hidden="true">
                        <use :xlink:href="`#icon-gailan_SSL_sel`"></use>
                      </svg>
                    </p>
                  </div>
                  <dl>
                    <dt>SSL Certificate (SSL)</dt>
                    <dd>
                      virtual server that runs in a secure and isolated
                      environment.
                    </dd>
                  </dl>
                </div>
              </div>
            </el-col>
          </router-link>
          -->

          <!-- <router-link :to="{ path: '/ip', query: {} }">
            <el-col :sm="12" :lg="8">
              <div class="grid-content bg-purple">
                <div class="products-item">
                  <div class="icon-img">
                    <p class="nor-icon">
                      <svg class="icon" aria-hidden="true">
                        <use :xlink:href="`#icon-gailan_gaofangIP_nor`"></use>
                      </svg>
                    </p>
                    <p class="hover-icon">
                      <svg class="icon" aria-hidden="true">
                        <use :xlink:href="`#icon-gailan_gaofangIP_sel`"></use>
                      </svg>
                    </p>
                  </div>
                  <dl>
                    <dt>Anti-DDoS IP</dt>
                    <dd></dd>
                  </dl>
                </div>
              </div>
            </el-col>
          </router-link> -->
        </el-row>
      </div>
    </div>

    <div class="home-support">
       <h2>{{ $t('overview.support.header') }}</h2>
      <div class="support-wrap">
        <el-row :gutter="20">

        <el-col :sm="12" :lg="8">
          <a :href="wwwUrl+'/help'" target="_blank">
            <div  class="grid-content bg-purple">
              <div class="support-item">
                <span>
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-list"></use>
                  </svg>
                </span>
                <p>{{ $t('overview.support.guide') }}</p>
              </div>
            </div>
          </a>
          </el-col>


          <el-col :sm="12" :lg="8">
            <a :href="wwwUrl+'/help'" target="_blank">
            <div  class="grid-content bg-purple">
              <div class="support-item">
                 <span>
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-docu"></use>
                  </svg>
                </span>
                <p>{{ $t('overview.support.faq') }}</p>
              </div>
            </div>
          </a>
          </el-col>


            <el-col :sm="12" :lg="8">
              <a :href="wwwUrl+'/contact'" target="_blank">
            <div class="grid-content bg-purple">
              <div class="support-item">
                 <span>
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-us"></use>
                  </svg>
                </span>
                <p>{{ $t('overview.support.contact') }}</p>
              </div>
            </div>
              </a>
            </el-col>

        </el-row>
      </div>
      <Recharge ref="rechargeModal"/>
    </div>
  </div>
</template>
<script>
import Recharge from "@/components/user/Recharge";
export default {
  name: 'overview',
  data() {
    return {
      wwwUrl:process.env.WWW_URL,
      balance: 0,
      log_money: 0,
      recharge: 0,
      copyurl:'https://www.yisu.com/?ref=8860036-6G8860036-6G88860036-6G8860036-6G88860036-6G8860036-6G'
    };
  },
  components: {
    Recharge,
  },
  methods: {
    clipboardSuccessHandler ({ value, event }){
      this.$message.success('Copied to clipboard.');
    },
    clipboardErrorHandler ({ value, event }) {
      this.$message.error('Copy fail.');
    },
    rechargeItem(){
      this.$refs.rechargeModal.getPayments();
      this.$refs.rechargeModal.showChange();
    },
    getUserMonthlyConsumption() {
      this.$http
        .post("/home/user/getUserMonthlyConsumption", {})
        .then((response) => {
          let res = response.data.data;
          if (response.data.code !== 0) {
            this.$message.error(response.data.message)
            return false
          }
          this.balance = res.balance;
          this.log_money = res.log_money;
        })
        .catch((err) => {
          this.$util.handleErr(err);;
        });
    },
    jump() {
      var tempwindow = window.open("_blank");
      tempwindow.location =
        "http://demo.yisu-inc.com/yisu%20cloud(international)/%E5%B8%AE%E5%8A%A9%E6%96%87%E6%A1%A3-%E9%A6%96%E9%A1%B5.html";
    },

  },
  created() {
    this.recharge = this.$route.query.recharge;
    this.getUserMonthlyConsumption();
  },
  mounted() {
    if(this.recharge == 1) {
      this.rechargeItem();
    }
  },
};
</script>





<style scoped lang="scss">
.el-col {
  padding-left: 0;
}
.home-wrap {
  h2 {
    font-size: 24px;
    font-weight: 500;
    color: #0f1e33;
    line-height: 24px;
    margin-bottom: 24px;
  }

  .grid-card {
    height: 208px;
    padding: 32px;
    margin-bottom: 48px;
    border: 1px solid #e1e2e6;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    ul {
      width: 100%;

      li {
        width: 50%;
        float: left;

        p:first-child {
          font-size: 32px;
          font-weight: 600;
          color: #0f1e33;
          line-height: 36px;
          margin-bottom: 8px;
        }

        p:nth-child(2) {
          font-size: 16px;
          font-weight: 500;
          color: #0f1e33;
          line-height: 16px;
        }
      }
    }

    > a {
      display: block;
      width: 100%;
      height: 48px;
      font-size: 16px;
      text-align: center;
      font-weight: 500;
      color: #3377ff;
      line-height: 48px;
      background: #eff4ff;
      border: 1px solid #eff4ff;
    }

    .grid-card-info {
      dt {
        margin-bottom: 12px;
        height: 16px;
        p {
          float: left;
        }
        a {
          float: right;
          color: #3377ff;
        }
      }

      dd {
        font-size: 16px;
        font-weight: 400;
        color: #5e6d81;
        line-height: 24px;
      }
    }

    .copyurl {
      width: 100%;
      height: 48px;
      background: #eff4ff;
      padding: 16px 60px 16px 16px;
      font-size: 16px;
      color: #5e6d81;
      line-height: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      position: relative;
      .copy {
        position: absolute;
        display: inline-block;
        cursor: pointer;
        right: 32px;
        top: 16px;
        width: 16px;
        height: 16px;
        font-size: 13px;
        color: #3377ff;
        font-weight: bold;
        z-index: 6;
      }
    }
  }

  .home-products {
    margin-bottom: 48px;

    .products-wrap {
      width: 100%;
      padding: 16px 56px;
      border: 1px solid #e1e2e6;

      .products-item {
        display: flex;
        margin: 40px 0;

        &:hover {
          .icon-img {
            .nor-icon {
              display: none;
            }
            .hover-icon {
              display: block;
            }
          }
        }

        .icon-img {
          flex-shrink: 0;
          width: 48px;
          height: 48px;
          margin-right: 12px;
          svg {
            width: 48px;
            height: 48px;
            font-size: 48px;
            vertical-align: top;
          }
          .nor-icon {
            display: block;
            svg{
              filter:drop-shadow(#5e6d81 0px 0);
            }
          }
          .hover-icon {
            display: none;
          }
        }

        dl {
          flex: 1;
          width: 100%;

          dt {
            font-size: 16px;
            font-weight: bold;
            color: #0f1e33;
            line-height: 16px;
            margin-bottom: 12px;
          }

          dd {
            width: 95%;
            font-size: 12px;
            text-align: left;
            color: #5e6d81;
            line-height: 20px;
          }
        }
      }
    }
  }

  .home-support {
    // margin-bottom: 48px;
    .support-wrap {
      .support-item {
        height: 148px;
        padding: 33px;
        margin-bottom: 48px;
        border: 1px solid #e1e2e6;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;

         &:hover{
          span svg{
            fill: #3377FF !important;
          }
        }

        span{
          display: inline-block;
          width: 44px;
          height: 44px;
          svg{
            width: 44px;
            height: 44px;
            font-size: 44px;
            fill: #9EA7B3 !important;
          }
        }

        p {
          font-size: 16px;
          font-weight: 500;
          color: #0f1e33;
          line-height: 16px;
        }
      }
    //   .el-row a:nth-child(1) .el-col{
    //     .support-item i {
    //       background: url(../../assets/images/support1.png);
    //     }
    //   }
    //   .el-row a:nth-child(2) .el-col{
    //     .support-item i {
    //       background: url(../../assets/images/support2.png);
    //     }
    //   }
    //  .el-row a:nth-child(3) .el-col{
    //     .support-item i {
    //       background: url(../../assets/images/support3.png);
    //     }
    //   }
    }
  }
}
.support-wrap a,.products-wrap a{
  display: block;
}


@media screen and (max-width: 768px) {
  .home-wrap {
    h2 {
      font-size: 18px;
      line-height: 18px;
      margin-bottom: 16px;
    }
    .grid-card {
      padding: 24px 16px;
      height: auto;
      ul {
        margin-bottom: 16px;
        li {
          p:first-child {
            font-size: 18px;
            line-height: 20px;
          }
          p:nth-child(2) {
            font-size: 12px;
          }
        }
      }
    }
    .right-box {
      display: none;
    }

    .home-products .products-wrap {
      padding: 0;
      border: none;
      .products-item {
        margin: 0 0 16px 0;
        padding: 16px;
        border: 1px solid #e1e2e6;
        dl dt {
          margin-bottom: 6px;
        }
        dl dd {
          font-size: 12px;
          line-height: 16px;
        }
      }
    }
    .home-support .support-wrap {
      .el-col-24 {
        width: 33.33333%;
      }
      .support-item {
        height: 130px;
        padding: 16px 0;
        display: flex;
        flex-direction: column;
        justify-content: start;
        i {
          margin-bottom: 12px;
        }
        p {
          font-size: 12px;
          font-weight: 500;
          color: #0f1e33;
          line-height: 20px;
          text-align: center;
          font-weight: bold;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/overview/OverView.vue